/* eslint-disable no-console */
console.log( 'Hello World! (from exe-site-logo block)' );
/* eslint-enable no-console */
